"use strict";function saveImage$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.saveImage$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.saveImage";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.1"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.1"},_a)),exports.saveImage$=saveImage$,exports.default=saveImage$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/saveImage.js
// module id = 1021
// module chunks = 106